import { createFileRoute } from "@tanstack/react-router";
import { TemplateManagePage } from "@client/components/doc-generation/template-manage-page";

export const Route = createFileRoute("/_app/doc-generation/templates")({
  component: TemplateManagePage,
});
